import React from "react";
import { useNavigate } from "react-router-dom";
import "./CourtNotFound.css";

function CourtNotFound() {
  const navigate = useNavigate();

  return (
    <div className="court_not_found_page">
      <img alt="Page not found"
        src={require("./images/futsal-ai.jpeg")}
        className="not-found-image"
      />
      <div className="not-found-content">
        <h1>Oops, Page Not Found</h1>
        <button onClick={() => navigate("/courts")}>Go to Courts</button>
      </div>
    </div>
  );
}

export default CourtNotFound;
